import type { ShopCart } from "~/models/ShopCart"

export const useShopCartStore = defineStore("shop_cart_store", {
    state: (): { shopCart: ShopCart; loadingShopCart: boolean } => ({
        shopCart: {
            items: [],
            count: 0,
            subtotal: 0,
            subtotal_formatted: "",
            shipment_formatted: "",
            to_pay_formatted: "",
            tax_formatted: "",
            is_wholesaler: false,
        },
        loadingShopCart: false,
    }),
    actions: {
        async clearCart() {
            this.shopCart = {
                items: [],
                count: 0,
                subtotal: 0,
                subtotal_formatted: '$00.00',
                shipment_formatted: '$00.00',
                to_pay_formatted: "",
                tax_formatted: "",
                is_wholesaler: false,
            }
        },
        async fetchShopCart(headers?: Record<string, string | number>) {
            const { get: fetchCart } = useOFetchCustom("shop-cart-data")

            this.loadingShopCart = true

            await fetchCart(undefined, {
                onSuccess: ({ data }) => {
                    this.shopCart = data
                    this.loadingShopCart = false
                },
                onError: () => {
                    this.loadingShopCart = false
                },
                headers: headers,
            })
        },
        async addToCart(body: any): Promise<any> {
            const { post } = useOFetchCustom("cart")

            return new Promise((resolve, reject) => {
                post(body, {
                    onSuccess: (res: any) => {
                        this.fetchShopCart()

                        resolve(res)
                    },
                    onError: (error: any) => {
                        reject(error)
                    },
                })
            })
        },
        async deleteShopCart(): Promise<any> {
            const { destroy: deleteCart } = useOFetchCustom("cart")
            this.loadingShopCart = true

            return new Promise((resolve, reject) => {
                deleteCart(undefined, {
                    onSuccess: () => {
                        this.clearCart()
                        this.loadingShopCart = false
                    },
                    onError: () => {
                        this.loadingShopCart = false
                    },
                })
            })
        },
    },
})
